import(/* webpackMode: "eager" */ "/vercel/path0/app/realtime-feedback/page.tsx");
